export const FETCH_PROJECT = "FETCH_PROJECT";
export const FETCH_PROJECT_SUCCESS = "FETCH_PROJECT_SUCCESS";
export const FETCH_PROJECT_FAILURE = "FETCH_PROJECT_FAILURE";

export const CREATE_PROJECT_REQUEST = "CREATE_PROJECT_REQUEST";
export const CREATE_PROJECT_SUCCESS = "CREATE_PROJECT_SUCCESS";
export const CREATE_PROJECT_FAILURE = "CREATE_PROJECT_FAILURE";

export const CHANGE_PROJECT_STATUS = "CHANGE_PROJECT_STATUS";
export const CHANGE_PROJECT_STATUS_SUCCESS = "CHANGE_PROJECT_STATUS_SUCCESS";
export const CHANGE_PROJECT_STATUS_FAILURE = "CHANGE_PROJECT_STATUS_FAILURE";

export const DELETE_CLIENT_PROJECT = "DELETE_CLIENT_PROJECT";
export const DELETE_CLIENT_PROJECT_SUCCESS = "DELETE_CLIENT_PROJECT_SUCCESS";
export const DELETE_CLIENT_PROJECT_FAILURE = "DELETE_CLIENT_PROJECT_FAILURE";

export const FETCH_CLIENT_PROJECT_SERVICE = "FETCH_CLIENT_PROJECT_SERVICE";
export const FETCH_CLIENT_PROJECT_SERVICE_SUCCESS = "FETCH_CLIENT_PROJECT_SERVICE_SUCCESS";
export const FETCH_CLIENT_PROJECT_SERVICE_FAILURE = "FETCH_CLIENT_PROJECT_SERVICE_FAILURE";

export const FETCH_CLIENT_PROJECT_DROPDOWN = "FETCH_CLIENT_PROJECT_DROPDOWN";
export const FETCH_CLIENT_PROJECT_DROPDOWN_SUCCESS = "FETCH_CLIENT_PROJECT_DROPDOWN_SUCCESS";
export const FETCH_CLIENT_PROJECT_DROPDOWN_FAILURE = "FETCH_CLIENT_PROJECT_DROPDOWN_FAILURE";
export const FETCH_CLIENT_PROJECT_DROPDOWN_CLEAR = "FETCH_CLIENT_PROJECT_DROPDOWN_CLEAR";

export const FETCH_MODULE_PROJECT_DROPDOWN = "FETCH_MODULE_PROJECT_DROPDOWN";
export const FETCH_MODULE_PROJECT_DROPDOWN_SUCCESS = "FETCH_MODULE_PROJECT_DROPDOWN_SUCCESS";
export const FETCH_MODULE_PROJECT_DROPDOWN_FAILURE = "FETCH_MODULE_PROJECT_DROPDOWN_FAILURE";
  
export const GET_PROJECT_SERVICE_MAPPING_REQUEST =
  "GET_PROJECT_SERVICE_MAPPING_REQUEST";
export const GET_PROJECT_SERVICE_MAPPING_SUCCESS =
  "GET_PROJECT_SERVICE_MAPPING_SUCCESS";
export const GET_PROJECT_SERVICE_MAPPING_FAILURE =
  "GET_PROJECT_SERVICE_MAPPING_FAILURE";

export const SAVE_PROJECT_SERVICE_MAPPING_REQUEST =
  "SAVE_PROJECT_SERVICE_MAPPING_REQUEST";
export const SAVE_PROJECT_SERVICE_MAPPING_SUCCESS =
  "SAVE_PROJECT_SERVICE_MAPPING_SUCCESS";
export const SAVE_PROJECT_SERVICE_MAPPING_FAILURE =
  "SAVE_PROJECT_SERVICE_MAPPING_FAILURE";

  export const GET_PROJECT_SERVICE_LIST_REQUEST =
  "GET_PROJECT_SERVICE_LIST_REQUEST";
export const GET_PROJECT_SERVICE_LIST_SUCCESS =
  "GET_PROJECT_SERVICE_LIST_SUCCESS";
export const GET_PROJECT_SERVICE_LIST_FAILURE =
  "GET_PROJECT_SERVICE_LIST_FAILURE";


export const GET_PROJECT_STATUS_BILLING_REQUEST = "GET_PROJECT_STATUS_BILLING_REQUEST";
export const GET_PROJECT_STATUS_BILLING_SUCCESS = "GET_PROJECT_STATUS_BILLING_SUCCESS";
export const GET_PROJECT_STATUS_BILLING_FAILURE = "GET_PROJECT_STATUS_BILLING_FAILURE";

export const SAVE_PROJECT_STATUS_BILLING_REQUEST = "SAVE_PROJECT_STATUS_BILLING_REQUEST";
export const SAVE_PROJECT_STATUS_BILLING_SUCCESS = "SAVE_PROJECT_STATUS_BILLING_SUCCESS";
export const SAVE_PROJECT_STATUS_BILLING_FAILURE = "SAVE_PROJECT_STATUS_BILLING_FAILURE";

export const CHANGE_PROJECT_BILLING_STATUS_REQUEST = "CHANGE_PROJECT_BILLING_STATUS_REQUEST";
export const CHANGE_PROJECT_BILLING_STATUS_SUCCESS = "CHANGE_PROJECT_BILLING_STATUS_SUCCESS";
export const CHANGE_PROJECT_BILLING_STATUS_FAILURE = "CHANGE_PROJECT_BILLING_STATUS_FAILURE";

export const GET_PROSERVICE_LIST_REQUEST = "GET_PROSERVICE_LIST_REQUEST";
export const GET_PROSERVICE_LIST_SUCCESS = "GET_PROSERVICE_LIST_SUCCESS";
export const GET_PROSERVICE_LIST_FAILURE = "GET_PROSERVICE_LIST_FAILURE";

export const GET_ORG_PROJECT_COUNT_REQUEST =
  "GET_ORG_PROJECT_COUNT_REQUEST";
export const GET_ORG_PROJECT_COUNT_SUCCESS =
  "GET_ORG_PROJECT_COUNT_SUCCESS";
export const GET_ORG_PROJECT_COUNT_FAILURE =
  "GET_ORG_PROJECT_COUNT_FAILURE";